<template>
  <div class="xg-dialog" v-if="dialogVisible">
    <div class="content">
      <div>您的手机号：{{ phone }}</div>
      <div>{{ msg }}</div>
      <div>如有疑问请联系客服电话: 18181947441</div>
      <div class="content-btn" v-if="isShowBtns">
        <div class="content-btn-item" v-if="payUrl" @click="toPay">去支付</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      phone: "",
      msg: "",
      payUrl: "", // 支付链接
    };
  },
  computed: {
    isShowBtns() {
      return this.payUrl;
    },
  },
  methods: {
    init({ flag, phone, msg, payUrl }) {
      this.dialogVisible = flag;
      this.phone = phone;
      this.msg = msg;
      this.payUrl = payUrl;
    },
    toggleDialog(flag) {
      this.dialogVisible = flag;
    },
    toPay() {
      window.open(this.payUrl, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.xg-dialog {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: #000000ba;
  z-index: 100;
}
.content {
  background: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #000;
  line-height: 1.5;
  padding: 30px 40px;
  border-radius: 4px;
  &-btn {
    display: flex;
    justify-content: center;
    color: #fff;
    padding-top: 10px;
    &-item {
      padding: 0px 10px;
      background: #00a13b;
      border-radius: 4px;
      cursor: pointer;
      transition: cubic-bezier(0.165, 0.84, 0.44, 1) 0.1s;
      &:hover {
        opacity: 0.8;
      }
    }
  }
}
</style>